import configJson from './publish.config.json';

type Env = 'dev' | 'prod';

export interface AppConfig {
  VITE_WEAVE_OKTA_CLIENT_ID: string;
  VITE_WEAVE_OKTA_ISSUER: string;
  VITE_WEAVE_APP_SOURCE: string;
  VITE_WEAVE_API: string;
}

export interface EnvConfig {
  displayName: string;
  slug: string;
  sites: { host: string; env: Env }[];
  env: {
    dev: AppConfig;
    prod: AppConfig;
  };
}

const envConfig = configJson as EnvConfig;

export const appConfig: AppConfig = (() => {
  let env: Env;

  // Allow local development to use the dev or prod config selected by ENV_NAME.
  // Production builds ignore this override and select the config by hostname.
  const injectedEnv = import.meta.env.VITE_ENV_NAME as Env | undefined;

  if (import.meta.env.DEV && (injectedEnv === 'dev' || injectedEnv === 'prod')) {
    env = injectedEnv;
  } else if (
    import.meta.env.MODE === 'development' ||
    import.meta.env.MODE === 'dev' ||
    window.location.hostname === 'integration-dashboard.weavedev.net' ||
    /-dev\.f\.weavedev\.net$/.test(window.location.hostname) || // PR preview dev hosts, e.g. `integration-dashboard-1234-dev.f.weavedev.net`
    window.location.hostname.includes('dev.f.weavedev')
  ) {
    env = 'dev';
  } else {
    env = 'prod';
  }

  return envConfig.env[env];
})();
